import { useAppSelector } from 'app/core/hooks'
import { selectBannerCom0102 } from 'app/core/services/com/com.service'
import {
    selectorMainBanner,
    selectorProductBanner,
} from 'app/core/slices/com/banner.slice'

export const useBanner = (kind: 'main' | 'product') => {
    const selector =
        kind === 'main' ? selectorMainBanner : selectorProductBanner
    const banners = useAppSelector(selector)
    //베너를 땡겼는데 데이터가 없다면... 근데 베너 데이터가 없는 경우가 있나?
    selectBannerCom0102.useQuery(null, {
        skip: false,
        refetchOnMountOrArgChange: false,
    })
    return banners
}
